module.exports = __webpack_public_path__ + "img/photo-0050.4eaab2e4.jpg";